<app-spinner [loading]="spinning()"></app-spinner>
@if(drilldown()) {
  <app-ca-details
    [value]="drilldown()"
    [crl]="crl()"
    (back)="onBack()"
    (renew)="onRenew($event)"
    (revoke)="onRevoke($event)"
    (generateCrl)="onGenerateCrl($event)"
    (closeCrl)="onCloseCrl()"
  ></app-ca-details>
}
@else if(edit()) {
  <app-create-ca
    edit
    [editValue]="edit()"
    [creating]="saving()"
    (update)="onSave($event)"
    (cancelCreate)="onCancel()"
    [csr]="csr"
    [loadingCsr]="loadingCsr"
    (needCsr)="onNeedCsr($event)"
    (importCertChain)="onImportCertChain($event)"
    [importingCertChain]="importingCertChain"
    [importedCertChain]="importedCertChain"
  ></app-create-ca>
}
@else {
  <app-calist-main-table></app-calist-main-table>
}
